<template>
    <div v-if="pdfFile || txtFile || csvFile">
        <b-button v-if="pdfFile" :href="pdfFile" v-b-popover.hover.top="'View PDF Report'" variant="outline-primary" pill size="sm" target="_blank" class="mx-1">pdf</b-button>
        <b-button v-if="txtFile" :href="txtFile" v-b-popover.hover.top="'View Text Report'" variant="outline-primary" pill size="sm" target="_blank" class="mx-1">txt</b-button>
        <b-button v-if="csvFile" :href="csvFile" v-b-popover.hover.top="'View CSV Report'" variant="outline-primary" pill size="sm" target="_blank" class="mx-1">csv</b-button>
    </div>
    <div v-else>
      No Reports
    </div>
</template>

<script>
import { downloadURLForEntity } from '#/models/entities';

export default {
  props: {
    jobItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    pdfFile() {
      return this.reportForType('pdf');
    },
    txtFile() {
      return this.reportForType('txt');
    },
    csvFile() {
      return this.reportForType('csv');
    },
  },
  methods: {
    reportForType(reportExtension) {
      for (let x = 0; x < this.jobItem.expandedReportsList.length; x += 1) {
        const report = this.jobItem.expandedReportsList[x];
        if (report.name.split('.').pop() === reportExtension) {
          return downloadURLForEntity(report);
        }
      }
      return undefined;
    },
  },
};
</script>
